import styled from 'styled-components'

export const PageLayout = styled.div`
  margin: 3em auto;
  padding: 0 2em;
  max-width: 48em;
`

export const LargePageLayout = styled(PageLayout)`
  max-width: 64em;
`

export const ErrorMessage = styled.p`
  color: #d24444ff;
`
